/**
 * Takes an iframe element and sets its direct image child to full width
 * @param {Element} iframe 
 */
const setImageIframeWide = (iframe) => {
  const pdfAsImage = iframe.contentWindow.document.querySelector("body > img");
  // Is the PDF really just an image?
  if (pdfAsImage) {
    pdfAsImage.style.width="100%";
  }
}

/**
 * Provide a query string which targets pdf iframes, if just an image is found
 * within the iframe, set the image's width 100% horizontally.
 * @param {string} queryString 
 */
const iframeIosHelper = (queryString = "[data-pdf-iframe]") => {
  const pdfIframes = document.querySelectorAll(queryString);
  Array.from(pdfIframes).forEach( (iEl) => {
    // if iframe was already loaded
    setImageIframeWide(iEl);
    // listen for the load event on the iframe, this also handles src attr change
    iEl.addEventListener('load', function() {
      setImageIframeWide(iEl);
    });
  })
}

export default iframeIosHelper;